/* eslint-disable no-unused-vars */

import { getValue } from 'firebase/remote-config';
import { remoteConfig } from '../apis/firebase';

/**
 * Keys for Firebase Remote Config keys.
 * Can be used when calling {@link remoteConfig}'s `getValue()`
 *
 * @enum {string}
 */
const RemoteConfigKeys = {
  ExmapleKey: 'EXAMPLE_KEY',
  CredentialingV2MinAppVersion: 'CREDENTIALING_V2_MIN_APP_VERSION',
  OnsiteInterviewThresholdInMinutes: 'ONSITE_INTERVIEW_THRESHOLD_MINUTES',
  PermanentRecruiterIds: 'PERMANENT_RECRUITER_IDS',
  ShowClockInOutW2States: 'SHOW_CLOCK_IN_OUT_W2_STATES',
};

/**
 * Utility object for accessing Firebase Remote Config values.
 * Provides type-safe methods to retrieve various configuration parameters.
 */
export const RemoteConfigUtils = {
  getExample: () => getValue(remoteConfig, RemoteConfigKeys.ExmapleKey).asNumber(),

  getCredentialingV2MinAppVersion: () =>
    getValue(remoteConfig, RemoteConfigKeys.CredentialingV2MinAppVersion).asString(),

  getOnsiteInterviewThresholdInMinutes: () =>
    getValue(remoteConfig, RemoteConfigKeys.OnsiteInterviewThresholdInMinutes).asNumber(),

  getPermanentRecruiterIds: () =>
    getValue(remoteConfig, RemoteConfigKeys.PermanentRecruiterIds).asString()?.split(','),

  getShowClockInOutW2States: () =>
    getValue(remoteConfig, RemoteConfigKeys.ShowClockInOutW2States).asString()?.split(','),
};

/**
 * Compares two semver version strings (e.g. "1.2.3").
 * Returns true if `version` is greater than or equal to `minVersion`.
 */
export const isVersionAtLeast = (version, minVersion) => {
  if (!version || !minVersion) return false;

  const vParts = version.split('.').map(Number);
  const mParts = minVersion.split('.').map(Number);
  const length = Math.max(vParts.length, mParts.length);

  for (let i = 0; i < length; i++) {
    const v = vParts[i] || 0;
    const m = mParts[i] || 0;
    if (v > m) return true;
    if (v < m) return false;
  }

  return true;
};
